"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifiersToDatesInMonth = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var modifiersToDatesInMonth = function (modifiers, currentMonth) {
    var mods = Array.isArray(modifiers) ? modifiers : [modifiers];
    var befores = mods.filter(function (mod) { return "before" in mod; });
    var beforeDates = [];
    if (!!befores.length) {
        befores.sort(function (a, b) { return (a.before > b.before ? -1 : 1); });
        beforeDates.push.apply(beforeDates, getBeforeDates(currentMonth, befores[0]));
    }
    var afters = mods.filter(function (mod) { return "after" in mod; });
    var afterDates = [];
    if (!!afters.length) {
        afters.sort(function (a, b) { return (a.after > b.after ? 1 : -1); });
        afterDates.push.apply(afterDates, getAfterDates(currentMonth, afters[0]));
    }
    var remainingDates = mods.reduce(function (final, mod) {
        var dates = [];
        if (mod instanceof Date) {
            dates.push(mod);
        }
        if (mod.daysOfWeek) {
            dates.push.apply(dates, getDayOfWeekDates(currentMonth, mod));
        }
        return __spreadArray(__spreadArray([], final, true), dates, true);
    }, []);
    return __spreadArray(__spreadArray(__spreadArray([], beforeDates, true), afterDates, true), remainingDates, true);
};
exports.modifiersToDatesInMonth = modifiersToDatesInMonth;
var getDayOfWeekDates = function (currentMonth, mod) {
    var dates = [];
    var i = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
    while (i.getMonth() === currentMonth.getMonth()) {
        if (mod.daysOfWeek.includes(i.getDay())) {
            dates.push(new Date(i));
        }
        i.setDate(i.getDate() + 1);
    }
    return dates;
};
var getBeforeDates = function (currentMonth, mod) {
    var count = 0;
    if (currentMonth.getMonth() === mod.before.getMonth() &&
        currentMonth.getFullYear() === mod.before.getFullYear()) {
        count = mod.before.getDate() - 1;
    }
    else if (currentMonth < mod.before) {
        count = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0).getDate();
    }
    return count > 0
        ? Array(count)
            .fill(undefined)
            .map(function (_, index) {
            return new Date(currentMonth.getFullYear(), currentMonth.getMonth(), index + 1);
        })
        : [];
};
var getAfterDates = function (currentMonth, mod) {
    var count = 0;
    var monthTotalDays = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0).getDate();
    if (currentMonth.getMonth() === mod.after.getMonth() &&
        currentMonth.getFullYear() === mod.after.getFullYear()) {
        count = monthTotalDays - mod.after.getDate();
    }
    else if (currentMonth > mod.after) {
        count = monthTotalDays;
    }
    return count > 0
        ? Array(count)
            .fill(undefined)
            .map(function (_, index) {
            return (0, dayjs_1.default)(Date.UTC(currentMonth.getFullYear(), currentMonth.getMonth(), monthTotalDays - index)).toDate();
        })
        : [];
};
